<div class="surface-card border-round flex flex-column gap-3 p-3">
  <div class="font-semibold text-sm">
    {{ 'REVISION' | translate }}: {{ config?.item?.revision }}
  </div>
  <div class="text-sm">
    {{ 'LAST_UPDATE' | translate }} :
    {{ config?.item?.updatedDateTime | defaultDateFormatPipe }}
  </div>
  <div
    class="inline-flex px-4 py-2 align-items-center cursor-pointer hover-opacity gap-2"
    (click)="openRevisionHistoryModal()"
  >
    <i class="pi pi-clock text-xs"></i>
    <div class="text-xs">{{ 'VIEW_REVISION_HISTORY' | translate }}</div>
  </div>
</div>
